import React from 'react'
import './Sun.scss'

const Sun = ({changeTimeOfDay}) => (
  <svg
    role="presentation"
    tabIndex="0"
    onClick={changeTimeOfDay}
    onKeyPress={changeTimeOfDay}
    className="hero__image--sun"
    viewBox="0 0 87 79.2"
  >
    <path
      className="sun--light"
      d="M25.4,44.1c0.1-0.1,0.1-0.2,0.1-0.4c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.2-0.2l-21-7l21.3-5.3
				c0.1,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.3,0-0.4c0,0-9.6-16.2-9.6-16.2L35,23.2c0.1,0.1,0.2,0.1,0.4,0s0.2-0.2,0.2-0.3l3.5-21.3
				L46.2,22c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.3,0,0.4-0.1L62.1,4.3l-4.7,23.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.1
				c0.1,0.1,0.2,0.1,0.4,0.1l23.6-2.1L61.9,40c-0.1,0.1-0.2,0.2-0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.1,0.2,0.2l19.2,8.5l-19.6,1
				c-0.1,0-0.3,0.1-0.3,0.2c-0.1,0.1-0.1,0.3,0,0.4l9.1,18L52,55.5c-0.1-0.1-0.3-0.1-0.4,0s-0.2,0.2-0.2,0.3l0.3,21.8L43,60.4
				c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.3,0-0.4,0.2L32,73.6l1.5-19c0-0.1,0-0.2,0-0.2c0,0-0.1-0.1-0.1-0.1
				c-0.1-0.1-0.2-0.1-0.4-0.1l-21.5,5.6L25.4,44.1z"
    />
    <path
      className="sun--medium"
      d="M62.2,40.1L83,25.4l-24.8,2.3c-0.1-0.1-0.2-0.3-0.3-0.4l4.9-24.6L47.3,20.8c-0.3-0.1-0.7-0.1-1-0.2L39,0
				l-3.8,22.6l-20-9.4l10.3,17.3L2.8,36.1l22.3,7.5L10.2,60.3l22.9-6l-1.6,20.4l11.1-14.4L52,79.2l-0.2-23.6l19.5,14l-9.7-19.2
				l21.3-1.1L62.2,40.1z M75.1,29l-13.3,9.1c-0.1-2.7-0.7-5.4-2.1-8c0,0,0,0,0,0L75.1,29z M59,10l-3,15.2c-1.9-1.7-4.2-3-6.6-3.8L59,10
				z M39.5,6.1L44,20.5c-2.2,0-4.4,0.3-6.5,1.2L39.5,6.1z M20.9,18.2L33.1,24c-2.2,1.6-4,3.7-5.2,6.1L20.9,18.2z M11.1,37l15.6-4.2
				c-0.9,2.9-1.2,5.9-0.6,9L11.1,37z M27,45.1c0.2,0.6,0.5,1.2,0.8,1.8c1.1,2.2,2.6,4,4.4,5.5l-15,4L27,45.1z M35.4,54.4
				c2.2,1.2,4.7,1.9,7.2,2L33,71.2L35.4,54.4z M44,56.5c2,0,4-0.4,6-1.1l1,19.1L44,56.5z M69.1,67.3L53,54c1.9-1.1,3.6-2.6,4.9-4.3
				L69.1,67.3z M59.2,47.9c1.1-1.7,1.8-3.7,2.2-5.6l17.2,6.4L59.2,47.9z"
    />
    <path
      className="sun--dark"
      d="M59.9,38.2c0,10-8.1,18-18,18c-6.9,0-13-3.9-16-9.7c2.8,1.8,6.1,2.9,9.7,2.9c10,0,18-8.1,18-18
				c0-3-0.7-5.8-2-8.3C56.6,26.2,59.9,31.8,59.9,38.2z"
    />
  </svg>
)

export default Sun
